import { FC, SVGProps } from 'react';

export const GreenArrowUp: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M1.66667 5.83331L6.33333 1.16665L11 5.83331" stroke="#10C79B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);
